import React from "react";

const Section2 = ({ state, onChange, onAddRow, onRemoveRow, formData, setFormData, monthly_report_observations, set_monthly_report_observations, onRemoveObservationsRow, onAddObservationsRow,
    monthly_report_delay_reason, onChange_monthly_report_observations, onChange_monthly_report_delay_reason, onAddDelayReasonRow, onRemoveDelayReasonRow
}) => {

    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-12 ">
                    <div className="appraisal-report-table-responsive">
                        <table className="assessment-table" cellSpacing={0}>
                            <tbody>
                                {/* Title */}
                                <tr>
                                    <td className="hd-s2 pd10" colSpan={10}>
                                        <p>3.　Progress of work  (no need to fill the % of progress)																			</p>
                                    </td>
                                </tr>

                                {/* Header Row */}
                                <tr>
                                    <td className="td-s1" colSpan={3}>
                                        <p className="s1">On Schedule</p>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={formData.on_schedule.value || ""}
                                            onChange={(e) =>
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    on_schedule: { ...prev.on_schedule, value: e.target.value },
                                                }))
                                            }
                                        />
                                    </td>
                                    <td className="td-s1" colSpan={3}>
                                        <p className="s1">Minor Delay</p>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={formData.minor_delay.value || ""}
                                            onChange={(e) =>
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    minor_delay: { ...prev.minor_delay, value: e.target.value },
                                                }))
                                            }
                                        />
                                    </td>
                                    <td className="td-s1" colSpan={4}>
                                        <p className="s1">Affecting Delivery</p>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={formData.affecting_delivery.value || ""}
                                            onChange={(e) =>
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    affecting_delivery: { ...prev.affecting_delivery, value: e.target.value },
                                                }))
                                            }
                                        />
                                    </td>
                                </tr>


                                {/* Dynamic Rows */}
                                <tr >
                                    <td className="td-s1 text-center">#</td>

                                    <td className="td-s1">
                                        <p className="s1">Steel Cutting</p>
                                    </td>
                                    <td className="td-s1">
                                        <p className="s1">Block</p>
                                    </td>
                                    <td className="td-s1">
                                        <p className="s1">Erection</p>
                                    </td>
                                    <td className="td-s1">
                                        <p className="s1">Hull Outfitting</p>
                                    </td>
                                    <td className="td-s1">
                                        <p className="s1">Paint</p>
                                    </td>
                                    <td className="td-s1">
                                        <p className="s1">Machine Fitting</p>
                                    </td>
                                    <td className="td-s1">
                                        <p className="s1">Electric</p>
                                    </td>
                                    <td className="td-s1">
                                        <p className="s1">General</p>
                                    </td>
                                    <td className="td-s1">
                                        <p className="s1">Action</p>
                                    </td>
                                </tr>
                                {/* Dynamic Rows */}
                                {state.map((row, index) => (
                                    <tr key={index}>
                                        <td className="td-s1 text-center">{index + 1}</td>

                                        {/* Steel Cutting */}
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Steel Cutting"
                                                name="steel_cutting"
                                                value={row.steel_cutting.value}
                                                onChange={(e) => onChange(e, index)}
                                            />
                                        </td>

                                        {/* Block */}
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Block"
                                                name="block"
                                                value={row.block.value}
                                                onChange={(e) => onChange(e, index)}
                                            />
                                        </td>

                                        {/* Erection */}
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Erection"
                                                name="erection"
                                                value={row.erection.value}
                                                onChange={(e) => onChange(e, index)}
                                            />
                                        </td>

                                        {/* Hull Outfitting */}
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Hull Outfitting"
                                                name="hull_outfitting"
                                                value={row.hull_outfitting.value}
                                                onChange={(e) => onChange(e, index)}
                                            />
                                        </td>

                                        {/* Paint */}
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Paint"
                                                name="paint"
                                                value={row.paint.value}
                                                onChange={(e) => onChange(e, index)}
                                            />
                                        </td>

                                        {/* Machine Fitting */}
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Machine Fitting"
                                                name="machine_fitting"
                                                value={row.machine_fitting.value}
                                                onChange={(e) => onChange(e, index)}
                                            />
                                        </td>

                                        {/* Electric */}
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Electric"
                                                name="electric"
                                                value={row.electric.value}
                                                onChange={(e) => onChange(e, index)}
                                            />
                                        </td>

                                        {/* General */}
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="General"
                                                name="general"
                                                value={row.general.value}
                                                onChange={(e) => onChange(e, index)}
                                            />
                                        </td>

                                        {/* Remove Row */}
                                        <td className="tb-input-value text-center">
                                            <button
                                                type="button"
                                                style={{
                                                    backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                                    borderColor: "#2b5a7e"
                                                }}
                                                className="btn btn-danger btn-sm"
                                                onClick={() => onRemoveRow(index)}
                                            >
                                                Remove
                                            </button>
                                        </td>
                                    </tr>
                                ))}

                                {/* Add Row */}
                                <tr>
                                    <td colSpan={10}>
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-sm ms-2"
                                            style={{
                                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                                borderColor: "#2b5a7e"
                                            }}
                                            onClick={onAddRow}
                                        >
                                            + Add Row
                                        </button>
                                    </td>
                                </tr>
                            </tbody>

                        </table>
                        <table className="assessment-table" cellSpacing={0}>

                            <tbody>
                                {/* Title */}
                                <tr >
                                    <td className="td-s1 text-center">#</td>

                                    <td className="td-s1 text-start">
                                        <p className="s1">Observations/Outstandings</p>
                                    </td>

                                    <td className="td-s1">
                                        <p className="s1">Action</p>
                                    </td>
                                </tr>
                                {/* Dynamic Rows */}
                                {monthly_report_observations.map((row, index) => (
                                    <tr key={index}>
                                        <td className="td-s1 text-center">{index + 1}</td>

                                        {/* Steel Cutting */}
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Steel Cutting"
                                                name="steel_cutting"
                                                value={row.observations.value}
                                                onChange={(e) => onChange_monthly_report_observations(e, index)}
                                            />
                                        </td>



                                        {/* Remove Row */}
                                        <td className="tb-input-value text-center">
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm"
                                                style={{
                                                    backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                                    borderColor: "#2b5a7e"
                                                }}
                                                onClick={() => onRemoveObservationsRow(index)}
                                            >
                                                Remove
                                            </button>
                                        </td>
                                    </tr>
                                ))}

                                {/* Add Row */}
                                <tr>
                                    <td colSpan={10}>
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            style={{
                                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                                borderColor: "#2b5a7e"
                                            }}
                                            onClick={onAddObservationsRow}
                                        >
                                            + Add Row
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>


                        <table className="assessment-table" cellSpacing={0}>

                            <tbody>
                                {/* Title */}
                                <tr>
                                    <td className="td-s1 text-center">#</td>
                                    <td className="td-s1 text-start">
                                        <p className="s1">Reason of delay</p>
                                    </td>
                                    <td className="td-s1 text-start">
                                        <p className="s1">Counter Measure</p>
                                    </td>
                                    <td className="td-s1 text-start">
                                        <p className="s1">Evaluation of its Counter Measure</p>
                                    </td>
                                    <td className="td-s1">
                                        <p className="s1">Action</p>
                                    </td>
                                </tr>

                                {/* Dynamic Rows */}
                                {monthly_report_delay_reason.map((row, index) => (
                                    <tr key={index}>
                                        <td className="td-s1 text-center">{index + 1}</td>

                                        {/* Reason of delay */}
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Reason of delay"
                                                name="reason_of_delay"
                                                value={row.reason_of_delay.value}
                                                onChange={(e) => onChange_monthly_report_delay_reason(e, index)}
                                            />
                                        </td>

                                        {/* Counter Measure */}
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Counter Measure"
                                                name="count_measure"
                                                value={row.count_measure.value}
                                                onChange={(e) => onChange_monthly_report_delay_reason(e, index)}
                                            />
                                        </td>

                                        {/* Evaluation of Counter Measure */}
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Evaluation"
                                                name="evaluation"
                                                value={row.evaluation.value}
                                                onChange={(e) => onChange_monthly_report_delay_reason(e, index)}
                                            />
                                        </td>

                                        {/* Remove Row */}
                                        <td className="tb-input-value text-center">
                                            <button
                                                type="button"
                                                style={{
                                                    backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                                    borderColor: "#2b5a7e"
                                                }}
                                                className="btn btn-danger btn-sm"
                                                onClick={() => onRemoveDelayReasonRow(index)}
                                            >
                                                Remove
                                            </button>
                                        </td>
                                    </tr>
                                ))}

                                {/* Add Row */}
                                <tr>
                                    <td colSpan={5}>
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            onClick={onAddDelayReasonRow}
                                        >
                                            + Add Row
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Section2;
